import React from 'react';

import PropTypes from 'prop-types';

const FilePreview = ({ name, url }) => {
  const extension = name.split('.').pop();

  switch (extension) {
  case 'jpg':
  case 'jpeg':
  case 'gif':
  case 'png':
  case 'svg':
    return (
      <img src={url} alt={name} />
    )
  default:
    return (
      <div>
        <i className="fal fa-file" />
      </div>
    );
  }
};

FilePreview.propTypes = {
  name: PropTypes.string,
  url: PropTypes.string,
};

export default FilePreview;
